import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

interface Invite {
	sentAt?: Date | string | null
	acceptedAt?: Date | string | null
}

export const isInviteExpired = (invite?: Invite | null): boolean => {
	if (!invite?.sentAt || invite.acceptedAt) return false

	return dayjs().valueOf() >= dayjs.utc(invite.sentAt).add(72, 'hour').valueOf()
}
